import React from 'react';
import { Box, darken } from '@material-ui/core';

export interface INoteContainerProps {
    children: React.ReactNode;
    position?: 'left' | 'right';
    bgColor: string;
    fullWidth?: boolean;
}

export const NoteContainer = ({
    children,
    position = 'left',
    bgColor,
    fullWidth = false,
}: INoteContainerProps) => {
    const isRight = position === 'right';

    return (
        <Box
            display="flex"
            justifyContent={isRight ? 'flex-end' : 'flex-start'}
            mb={1}
            width={fullWidth ? '100%' : 'auto'}
        >
            <Box
                position="relative"
                style={{
                    background: bgColor,
                    padding: '12px 16px',
                    borderRadius: 8,
                    minWidth: fullWidth ? '100%' : 400,
                    maxWidth: fullWidth ? '100%' : 400,
                    wordBreak: 'break-word',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                }}
            >
                {children}

                <Box
                    style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        width: 0,
                        height: 0,
                        borderTop: `20px solid ${darken(bgColor, 0.15)}`,
                        borderLeft: '20px solid transparent',
                        borderTopRightRadius: 4,
                    }}
                />

                <Box
                    style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        width: 0,
                        height: 0,
                        borderTop: '20px solid rgba(0,0,0,0.05)',
                        borderLeft: '20px solid transparent',
                        transform: 'translate(-2px, 2px)',
                        zIndex: -1,
                    }}
                />
            </Box>
        </Box>
    );
};
